"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Loader, Mail } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetUpdatesWhenNewLabExplanationsArePublished() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="py-16 px-4 bg-background" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(20px)",
    transition: "opacity 150ms ease-out, transform 150ms ease-out"
  }}>
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl font-display font-bold text-foreground mb-3">Get updates when new lab values and explanations are published</h2>
        <p className="text-muted-foreground mb-8">
          Stay informed with the latest evidence-based lab value explanations delivered to your inbox.
        </p>

        <FormProvider className="w-full" formId="newsletter-subscription-home" sectionName="get-updates-section" defaultValues={{
        email: ""
      }} validationRules={{
        email: {
          required: true,
          pattern: "email"
        }
      }} submitText="Subscribe" successMessage="Thank you for subscribing! Check your inbox for confirmation.">
          <SubscriptionForm />
        </FormProvider>
      </div>
    </section>;
}
function SubscriptionForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-primary-light border border-primary rounded-md">
        <p className="text-primary-dark font-medium mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="w-full sm:w-auto">
          Subscribe Another Email
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="flex flex-col sm:flex-row gap-3 items-start">
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1 w-full">
              <FormControl>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 size-5 text-muted-foreground" />
                  <Input type="email" placeholder="Enter your email address" className="pl-11 h-11 focus-visible:ring-primary/30 focus-visible:border-primary transition-all duration-150" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <Button type="submit" disabled={isSubmitting} className="h-11 px-8 bg-accent text-foreground-accent hover:bg-accent-hover active:bg-accent-active shadow-soft transition-all duration-150 hover:scale-[0.98] active:scale-100 w-full sm:w-auto">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Subscribing...
            </> : "Subscribe"}
        </Button>
      </div>

      {submitError && <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-md">
          <p className="text-red-800 text-sm">{submitError}</p>
        </div>}
    </Form>;
}